// TODO: Complete client editing screen same as contractors
<template>
  <page-container :title="headerTitle" showBack>
    <v-container class="pa-0 ma-0" fluid>
      <v-card fluid elevation="0" class="pa-2" :loading="loading">
        <div class="d-flex flex-wrap flex-sm-wrap flex-no-wrap">
          <v-avatar class="ma-3" size="100" tile color="indigo">
            <span class="white--text headline">{{ initials }}</span>
          </v-avatar>
        </div>
      </v-card>
    </v-container>
  </page-container>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'

export default {
  name: 'ClientDetails',
  components: {
    PageContainer,
  },
  props: ['id', 'title'],
  data() {},
}
</script>